import React, { Component } from 'react';

import Title from '../../components/Title';
import Conteudo from '../../Conteudo';

import ListaVeiculos from './ListaVeiculos';
import ListaMoradores from './ListaMoradores';

export default class extends Component {
  render() {
    return (<div>
        <Title value="Diego Rivera » Perfil" />
        <Conteudo>
          <ListaMoradores />
          <ListaVeiculos />
        </Conteudo>
    </div>);
  }
}


// WEBPACK FOOTER //
// ./src/modules/unidade/Index.js